module.exports = __webpack_public_path__ + "static/img/device_tip.62664ba6.png";